import { formatToLocaleString } from "Formatting/formatNumber";
import React, { ReactElement } from "react";
import { PRESENTATION, ValueElement } from "./styled";

export enum VALUE_TYPE {
  KILOMETERS = "km",
  NOK_MONTH = "kr/mnd",
  NOK_YEAR = "kr/år",
  NOK = "kr",
  SQUARE_METERS = "kvm",
  LENGTH_FEET = "fot",
  HORSEPOWER = "HK",
  SPEED_KNOP = "knop",
}

interface Props {
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  isNegativeNumber?: boolean;
  presentation?: PRESENTATION;
  boldValue?: boolean;
  boldType?: boolean;
  largeValue?: boolean;
  disabledColor?: boolean;
  type: VALUE_TYPE;
  value?: number;
  id?: string;
}

export const NumberValue = ({
  as = "span",
  className,
  isNegativeNumber,
  presentation = PRESENTATION.DEFAULT,
  boldValue = false,
  boldType = false,
  largeValue = false,
  disabledColor = false,
  type,
  value,
  id,
}: Props): ReactElement<Props> => {
  const getExtraClass = className ? className : "";
  const spanClassValue = `${getExtraClass} value-element__value`;
  const spanClassType = `${getExtraClass} value-element__type`;
  const getNegativeNumberPrefix = isNegativeNumber ? "\u2212" : "";
  return (
    <ValueElement
      as={as}
      presentation={presentation}
      boldValue={boldValue}
      boldType={boldType}
      largeValue={largeValue}
      disabledColor={disabledColor}
    >
      <span className={spanClassValue} id={id}>
        {presentation === PRESENTATION.ADDITION && value ? "+ " : ""}
        {value
          ? `${getNegativeNumberPrefix}${formatToLocaleString(
              Math.round(value),
            )}`
          : "0"}
      </span>
      {"\u2009"}
      <span className={spanClassType}>{type}</span>
    </ValueElement>
  );
};
